import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import theme from '@/theme';

// Blue color for the entire application
const BLUE_COLOR = '#4361EE';

const ResourceBanner = () => {
  const { t } = useTranslation(['resources']);

  const [firstWord, secondWord, thirdWord] = t('resourceCenter').split(' ');

  return (
    <Box
      data-testid="resource-banner"
      sx={{
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        backgroundColor: BLUE_COLOR,
        padding: { lg: '40px 80px', sm: '20px 40px', xs: '20px 20px' },
        [theme.breakpoints.down('lg')]: { marginTop: '65px' },
        overflow: 'hidden',
      }}
    >
      {/* Background Pattern */}
      <Box
        data-testid="banner-background-pattern"
        sx={{
          position: 'absolute',
          right: 0,
          top: 0,
          height: '100%',
          width: '60%',
          zIndex: 0,
          opacity: 0.09,
        }}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 500 300"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern
              id="grid"
              width="50"
              height="50"
              patternUnits="userSpaceOnUse"
            >
              <path
                d="M 50 0 L 0 0 0 50"
                fill="none"
                stroke="white"
                strokeWidth="1.2"
              />
            </pattern>
          </defs>

          {/* Background grid */}
          <rect width="100%" height="100%" fill="url(#grid)" />

          {/* Diamond shapes */}
          <path
            d="M 300,0 L 500,200 L 300,400 L 100,200 Z"
            fill="none"
            stroke="white"
            strokeWidth="1.5"
          />
          <path
            d="M 300,50 L 450,200 L 300,350 L 150,200 Z"
            fill="none"
            stroke="white"
            strokeWidth="1.5"
          />
          <path
            d="M 300,100 L 400,200 L 300,300 L 200,200 Z"
            fill="none"
            stroke="white"
            strokeWidth="1.5"
          />

          {/* Center circle */}
          <circle
            cx="300"
            cy="200"
            r="25"
            fill="none"
            stroke="white"
            strokeWidth="1.5"
          />
          <circle
            cx="300"
            cy="200"
            r="50"
            fill="none"
            stroke="white"
            strokeWidth="1.5"
          />
          <circle
            cx="300"
            cy="200"
            r="75"
            fill="none"
            stroke="white"
            strokeWidth="1.5"
          />

          {/* Corner connector lines */}
          <line
            x1="100"
            y1="0"
            x2="0"
            y2="100"
            stroke="white"
            strokeWidth="1.5"
          />
          <line
            x1="400"
            y1="0"
            x2="500"
            y2="100"
            stroke="white"
            strokeWidth="1.5"
          />
          <line
            x1="0"
            y1="250"
            x2="50"
            y2="300"
            stroke="white"
            strokeWidth="1.5"
          />
          <line
            x1="450"
            y1="300"
            x2="500"
            y2="250"
            stroke="white"
            strokeWidth="1.5"
          />
        </svg>
      </Box>

      <Box
        sx={{ position: 'relative', zIndex: 1 }}
        data-testid="banner-content"
      >
        <Typography
          variant="h2"
          data-testid="banner-title"
          sx={{
            color: 'white',
            fontWeight: 700,
            fontSize: '2.5rem',
            mb: 0.5,
            mt: 1,
          }}
        >
          {firstWord}
          <br />
          {`${secondWord} ${thirdWord}`}
        </Typography>

        <Typography
          variant="h4"
          data-testid="banner-subtitle"
          sx={{
            color: 'white',
            fontWeight: 400,
            fontSize: '1.2rem',
            mt: 2,
          }}
        >
          {t('resourceCenterSubtitle')}
        </Typography>
      </Box>
    </Box>
  );
};

export default ResourceBanner;
